<template>
  <div class="columns is-mobile is-centered has-background-primary p-2">
    <h1 class="title is-4 has-text-white">UTILITA'</h1>
  </div>
  <div class="box">
    <div><br></div>
    <div><br></div>
    <div><br></div>
    <div class="columns is-mobile is-centered">
      <button class="button is-danger mx-1" v-if="!permettiElimina" @click="bPermettiElimina">Consenti l'eliminazione dei componenti</button>
      <button class="button is-danger mx-1" v-if="permettiElimina" @click="bPermettiElimina">Blocca l'eliminazione dei componenti</button>
      <button class="button is-danger mx-1" v-if="!mostraListiniInattivi" @click="bToggleMostraListiniInattivi">Visualizza i listini inattivi</button>
      <button class="button is-danger mx-1" v-if="mostraListiniInattivi" @click="bToggleMostraListiniInattivi">Nascondi i listini inattivi</button>
    </div>
    <div><br></div>
    <!-- <div class="columns is-mobile is-centered" v-if="downloadPronto=='in attesa'">
      <p>Preparazione del file in corso. Attendi alcuni secondi.</p>
    </div> -->
    <div class="columns is-mobile is-centered" v-if="downloadPronto==true">
      <a :href="JSonHtml" :download="generaNomeFile()">Seleziona per iniziare il download di {{ Object.keys(dbClienti).length }} clienti.</a>
    </div>
    <section class="section" v-if="credenzialiUtente.autorizzazione=='sviluppatore'">
      <div class="columns is-mobile is-centered">
        <button class="button is-danger" @click="toggleMostraInfoSviluppo">{{ mostraInfoSviluppo? 'Nascondi informazioni avanzate': 'Mostra informazioni avanzate' }} </button>
      </div>
    </section>
  </div>

  <div class="box mt-4" v-if="mostraInfoSviluppo">
    <h2 class="title is-5 has-text-primary">
      <span class="icon"><i class="fas fa-database"></i></span>
      Monitoraggio Database Ibrido in RAM
    </h2>
    
    <div class="columns has-text-centered mt-2">
        
      <div class="column">
        <div class="heading is-size-6">Clienti Totali</div>
        <div class="title is-3">{{ statsClienti.totali }}</div>
        
        <div class="level is-mobile mt-4">
          <div class="level-item">
            <div>
              <div class="heading has-text-danger">🔥 Caldi (Firestore)</div>
              <div class="title is-5 has-text-danger">{{ statsClienti.caldi }}</div>
            </div>
          </div>
          <div class="level-item">
            <div>
              <div class="heading has-text-info">❄️ Freddi (Storage)</div>
              <div class="title is-5 has-text-info">{{ statsClienti.freddi }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="is-divider-vertical" v-if="schermoLargo"></div>

      <div class="column">
          <div class="heading is-size-6">Contatti Totali</div>
          <div class="title is-3">{{ statsContatti.totali }}</div>
          
          <div class="level is-mobile mt-4">
              <div class="level-item">
                  <div>
                      <div class="heading has-text-danger">🔥 Caldi (Firestore)</div>
                      <div class="title is-5 has-text-danger">{{ statsContatti.caldi }}</div>
                  </div>
              </div>
              <div class="level-item">
                  <div>
                      <div class="heading has-text-info">❄️ Freddi (Storage)</div>
                      <div class="title is-5 has-text-info">{{ statsContatti.freddi }}</div>
                  </div>
              </div>
          </div>
      </div>

    </div>
  </div>

  <div class="box mt-4" v-if="mostraInfoSviluppo">
    <h2 class="title is-5 has-text-primary">
      <span class="icon"><i class="fas fa-cloud-download-alt"></i></span>
      Download File da Firebase Storage
    </h2>
    <p class="subtitle is-6 has-text-grey">
      Scarica file da Firebase Storage (es. i backup giornalieri in <code>backup/</code> o i file in <code>ricerca/</code>).
    </p>

    <div class="field">
      <label class="label">Nome file o percorso in Storage</label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <input 
            class="input" 
            type="text" 
            v-model="nomeFileStorage" 
            placeholder="Es. 2026-09-07 - LMC BU.json oppure backup/2026-09-07 - LMC BU.json"
            @keyup.enter="eseguiDownloadStorage"
          >
        </div>
        <div class="control">
          <button 
            class="button is-primary" 
            @click="eseguiDownloadStorage" 
            :class="{'is-loading': inCaricamentoDownloadStorage}"
            :disabled="inCaricamentoDownloadStorage || !nomeFileStorage.trim()">
            <span class="icon"><i class="fas fa-download"></i></span>
            <span>Download file</span>
          </button>
        </div>
        <div class="control">
          <button 
            class="button is-info is-outlined" 
            @click="caricaElencoBackup" 
            :class="{'is-loading': inCaricamentoElencoBackup}"
            title="Mostra / aggiorna la lista dei file presenti nella cartella backup">
            <span class="icon"><i class="fas fa-history"></i></span>
            <span>Elenco Backup</span>
          </button>
        </div>
      </div>
      <p class="help">
        Nota: Puoi inserire solo il nome del file (es. <code>2026-09-07 - LMC BU.json</code>): il sistema cercherà automaticamente sia il percorso esatto che all'interno della cartella <code>backup/</code>.
      </p>
    </div>

    <!-- Lista dei backup disponibili trovati su Storage -->
    <div v-if="elencoBackupDisponibili.length > 0" class="mt-4 p-3 has-background-light" style="border-radius: 6px;">
      <p class="heading has-text-weight-bold mb-2">Backup rilevati su Storage (clicca per selezionare e avviare il download):</p>
      <div class="tags">
        <span 
          v-for="fileBackup in elencoBackupDisponibili" 
          :key="fileBackup" 
          class="tag is-info is-light is-medium" 
          style="cursor: pointer;"
          @click="selezionaEScaricaBackup(fileBackup)"
          title="Clicca per scaricare questo backup">
          <span class="icon is-small mr-1"><i class="fas fa-file-archive"></i></span>
          {{ fileBackup }}
        </span>
      </div>
    </div>

    <div class="buttons mt-4">
      <button class="button is-danger is-small" @click="stop">Test STOP</button>
      <button class="button is-danger is-outlined is-small" @click="creaAreaRiservataTest">
        <span class="icon"><i class="fas fa-flask"></i></span>
        <span>Genera Area Clienti Test (ID 200 - Lav 1370)</span>
      </button>
    </div>
  </div>

  <div class="box mt-4" v-if="mostraInfoSviluppo">
      <h2 class="title is-5 has-text-primary">
        <span class="icon"><i class="fas fa-download"></i></span>
        Esportazione Selettiva
      </h2>
      <div class="field has-addons mt-4">
          <div class="control">
              <input class="input" type="text" v-model="collezioneDaEsportare" placeholder="Es. clienti, utilita...">
          </div>
          <div class="control">
              <div class="select">
                  <select v-model="formatoEsportazione">
                      <option value="json">Dati (JSON)</option>
                      <option value="md">Schema Struttura (MD)</option>
                  </select>
              </div>
          </div>
          <div class="control">
              <button 
                  class="button is-warning" 
                  @click="bEsportaCustom" 
                  :class="{'is-loading': inCaricamentoExport}">
                  Esporta
              </button>
          </div>
      </div>
    </div>

    <div class="box mt-4" v-if="mostraInfoSviluppo">
      <h2 class="title is-5 has-text-primary">
        <span class="icon"><i class="fas fa-file-download"></i></span>
        Download Documento Firestore
      </h2>
      <div class="field">
        <label class="label">Collezione (o percorso collezione)</label>
        <div class="control">
          <input class="input" type="text" v-model="collezioneDocDaScaricare" placeholder="Es. listini, clienti, utilita">
        </div>
      </div>
      <div class="field">
        <label class="label">ID Documento</label>
        <div class="control">
          <input class="input" type="text" v-model="idDocDaScaricare" placeholder="Es. 1, 1370, impostazioni">
        </div>
      </div>
      <div class="field">
        <div class="control">
          <button 
            class="button is-primary" 
            @click="bScaricaDocumento" 
            :class="{'is-loading': inCaricamentoDownloadDoc}">
            <span class="icon"><i class="fas fa-download"></i></span>
            <span>Scarica Documento (JSON)</span>
          </button>
        </div>
      </div>
    </div>

    <div class="box mt-4" v-if="mostraInfoSviluppo">
      <h2 class="title is-5 has-text-primary">
        <span class="icon"><i class="fas fa-file-upload"></i></span>
        Upload Documento Firestore
      </h2>
      <div class="field">
        <label class="label">Collezione (o percorso collezione)</label>
        <div class="control">
          <input class="input" type="text" v-model="collezioneDocDaCaricare" placeholder="Es. listini, clienti, utilita">
        </div>
      </div>
      <div class="field">
        <label class="label">ID Documento</label>
        <div class="control">
          <input class="input" type="text" v-model="idDocDaCaricare" placeholder="Es. 1, 1370, impostazioni">
        </div>
      </div>
      <div class="field">
        <label class="label">File JSON da caricare</label>
        <div class="file has-name is-fullwidth">
          <label class="file-label">
            <input class="file-input" type="file" accept=".json" @change="gestisciSelezioneFile">
            <span class="file-cta">
              <span class="file-icon">
                <i class="fas fa-upload"></i>
              </span>
              <span class="file-label">
                Scegli un file JSON...
              </span>
            </span>
            <span class="file-name" v-if="nomeFileJSONSelezionato">
              {{ nomeFileJSONSelezionato }}
            </span>
          </label>
        </div>
      </div>
      <div class="field">
        <div class="control">
          <button 
            class="button is-danger" 
            @click="bCaricaDocumento" 
            :class="{'is-loading': inCaricamentoUploadDoc}">
            <span class="icon"><i class="fas fa-upload"></i></span>
            <span>Carica Documento (JSON)</span>
          </button>
        </div>
      </div>
    </div>

    <div class="has-text-centered mt-4" v-if="mostraInfoSviluppo">
      <p class="is-size-7 has-text-grey">Larghezza schermo: {{ larghSchermo + 'px - ' + tipoSchermo() }}</p>
    </div>
</template>
  
<script setup>
  import { ref, computed } from 'vue';
  import { csvToArray } from '../code/gestioneCsv';
  import { dbContatti, dbClienti, testStop } from '../code/gestioneDB';
  import { dataCorrenteInversa, tipoSchermo, mostraInfoSviluppo, permettiElimina, mostraListiniInattivi } from '@/code/utilita';
  import { credenzialiUtente, db } from '../code/firebase';
  import { doc, getDoc, Timestamp, writeBatch, setDoc } from 'firebase/firestore';
  import { downloadFile, elencaFileBackup } from '../code/firestorage';
  import { getFunctions, httpsCallable } from 'firebase/functions';
  import { getApp } from 'firebase/app';

  const collezioneDaEsportare = ref('');
  const formatoEsportazione = ref('json');
  const inCaricamentoExport = ref(false);
  let larghSchermo = screen.availWidth;

  const collezioneDocDaScaricare = ref('');
  const idDocDaScaricare = ref('');
  const inCaricamentoDownloadDoc = ref(false);

  const collezioneDocDaCaricare = ref('');
  const idDocDaCaricare = ref('');
  const inCaricamentoUploadDoc = ref(false);
  const nomeFileJSONSelezionato = ref('');
  const contenutoFileJSONSelezionato = ref('');
  const nomeFileStorage = ref('');
  const inCaricamentoDownloadStorage = ref(false);
  const inCaricamentoElencoBackup = ref(false);
  const elencoBackupDisponibili = ref([]);
  const arrayFile = ref('');
  const JSonHtml = ref('');
  let testoFile = '';
  const reader = new FileReader();
  const readerDB = new FileReader();
  let downloadPronto = ref(false);
  
  // Calcolo statistiche Clienti Ibridi
  const statsClienti = computed(() => {
    let caldi = 0;
    let freddi = 0;
    if (dbClienti.value) {
      for (const id in dbClienti.value) {
        const cl = dbClienti.value[id];
        // La presenza nativa di _info identifica un JSON freddo
        if (cl && cl._info) {
          freddi++;
        } else {
          caldi++;
        }
      }
    }
    return { totali: caldi + freddi, caldi, freddi };
  });

  // Calcolo statistiche Contatti Ibridi
  const statsContatti = computed(() => {
    let caldi = 0;
    let freddi = 0;
    if (dbContatti.value) {
      for (const id in dbContatti.value) {
        const ct = dbContatti.value[id];
        if (ct && ct._info) {
          freddi++;
        } else {
          caldi++;
        }
      }
    }
    return { totali: caldi + freddi, caldi, freddi };
  });

  reader.onload = (e => {
    testoFile = e.target.result;
    // console.log(testoFile);
    arrayFile.value = csvToArray(testoFile);
  });

  readerDB.onload = (e => {
    testoFile = e.target.result;
    // console.log(testoFile);
  });
  
  function generaNomeFile() {
    return 'LMCGestionale - ' + dataCorrenteInversa() + '.lmc';
  }
  
  function toggleMostraInfoSviluppo() {
    mostraInfoSviluppo.value = mostraInfoSviluppo.value? false: true;
  }

  function bPermettiElimina() {
    if (permettiElimina.value) {
      permettiElimina.value = false;
    } else {
      permettiElimina.value = true;
    }
  }

  function bToggleMostraListiniInattivi() {
    mostraListiniInattivi.value = !mostraListiniInattivi.value;
  }

  function stop() {
    // Funzione di test
    testStop();
  }

  async function eseguiDownloadStorage() {
    if (!nomeFileStorage.value || !nomeFileStorage.value.trim()) {
      alert("Inserisci il nome o il percorso del file da scaricare.");
      return;
    }

    inCaricamentoDownloadStorage.value = true;
    try {
      const res = await downloadFile(nomeFileStorage.value);
      console.log('Download completato:', res);
    } catch (error) {
      console.error('Errore durante il download del file da Storage:', error);
      alert(`Impossibile scaricare il file.\n\n${error.message || error}`);
    } finally {
      inCaricamentoDownloadStorage.value = false;
    }
  }

  async function caricaElencoBackup() {
    inCaricamentoElencoBackup.value = true;
    try {
      const files = await elencaFileBackup();
      if (!files || files.length === 0) {
        alert("Nessun file di backup trovato nella cartella 'backup' di Firebase Storage.");
      }
      elencoBackupDisponibili.value = files;
    } catch (error) {
      console.error("Errore recupero elenco backup:", error);
      alert("Impossibile recuperare l'elenco dei backup: " + (error.message || error));
    } finally {
      inCaricamentoElencoBackup.value = false;
    }
  }

  function selezionaEScaricaBackup(nomeFile) {
    nomeFileStorage.value = nomeFile;
    eseguiDownloadStorage();
  }

  async function bEsportaCustom() {
    if (!collezioneDaEsportare.value.trim()) {
        alert("Inserisci il nome di una collezione valida.");
        return;
    }
    
    inCaricamentoExport.value = true;
    try {
      const functions = getFunctions(getApp());
      const esportaFunzione = httpsCallable(functions, 'esportaCollezioneCustom');
      
      const response = await esportaFunzione({
          nomeCollezione: collezioneDaEsportare.value.trim(),
          formato: formatoEsportazione.value
      });
      
      alert(response.data.message + `\nFile: ${response.data.file}`);
    } catch (error) {
      console.error('Errore chiamata function:', error);
      alert(error.message || 'Errore durante l\'esportazione.');
    } finally {
      inCaricamentoExport.value = false;
    }
  }

  async function bScaricaDocumento() {
    const coll = collezioneDocDaScaricare.value.trim();
    const id = idDocDaScaricare.value.trim();
    
    if (!coll || !id) {
      alert("Inserisci sia il nome della collezione che l'ID del documento.");
      return;
    }
    
    inCaricamentoDownloadDoc.value = true;
    try {
      const docRef = doc(db, coll, id);
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        alert(`Il documento con ID "${id}" nella collezione "${coll}" non esiste.`);
        return;
      }
      
      const dati = docSnap.data();
      const datiSerializzati = JSON.stringify(dati, (key, value) => {
        if (value && typeof value === 'object') {
          if ('seconds' in value && 'nanoseconds' in value) {
            try {
              return new Date(value.seconds * 1000).toISOString();
            } catch (e) {
              console.warn("Errore conversione data:", e);
            }
          }
        }
        return value;
      }, 2);

      const blob = new Blob([datiSerializzati], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${coll}_${id}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Errore durante il download del documento:", error);
      alert(`Impossibile scaricare il documento. Errore: ${error.message}`);
    } finally {
      inCaricamentoDownloadDoc.value = false;
    }
  }

  function gestisciSelezioneFile(event) {
    const file = event.target.files[0];
    if (!file) {
      nomeFileJSONSelezionato.value = '';
      contenutoFileJSONSelezionato.value = '';
      return;
    }
    nomeFileJSONSelezionato.value = file.name;
    
    const reader = new FileReader();
    reader.onload = (e) => {
      contenutoFileJSONSelezionato.value = e.target.result;
    };
    reader.readAsText(file);
  }

  async function bCaricaDocumento() {
    const coll = collezioneDocDaCaricare.value.trim();
    const id = idDocDaCaricare.value.trim();
    const jsonText = contenutoFileJSONSelezionato.value;
    
    if (!coll || !id) {
      alert("Inserisci sia il nome della collezione che l'ID del documento.");
      return;
    }
    if (!jsonText) {
      alert("Seleziona prima un file JSON valido da caricare.");
      return;
    }
    
    const conferma = confirm(`Sei sicuro di voler SOVRASCRIVERE il documento con ID "${id}" nella collezione "${coll}"?\n\nQuesta operazione sostituirà completamente i dati esistenti.`);
    if (!conferma) return;
    
    inCaricamentoUploadDoc.value = true;
    try {
      const parsedData = JSON.parse(jsonText, (key, value) => {
        const isoDateRegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
        if (typeof value === 'string' && isoDateRegExp.test(value)) {
          return Timestamp.fromDate(new Date(value));
        }
        return value;
      });
      
      const docRef = doc(db, coll, id);
      await setDoc(docRef, parsedData);
      
      alert(`Documento "${id}" nella collezione "${coll}" caricato con successo!`);
      nomeFileJSONSelezionato.value = '';
      contenutoFileJSONSelezionato.value = '';
    } catch (error) {
      console.error("Errore durante l'upload del documento:", error);
      alert(`Impossibile caricare il documento. Errore: ${error.message}`);
    } finally {
      inCaricamentoUploadDoc.value = false;
    }
  }

  async function creaAreaRiservataTest() {
    const batch = writeBatch(db); //[cite: 6]
    
    // Calcolo dei timestamp di riferimento
    const ora = new Date();
    const dataPassata = new Date(ora.getTime() - (7 * 24 * 60 * 60 * 1000)); // 7 giorni fa
    const dataFutura = new Date(ora.getTime() + (30 * 24 * 60 * 60 * 1000)); // Tra 30 giorni

    // Questionario di prova comune
    const questionarioMock = {
      "1": {
        titolo: "Raccolta Dati Anagrafici e Tecnici",
        campi: {
          nome: { txt: "Mario", obbligatorio: true },
          cognome: { txt: "Rossi", obbligatorio: true },
          telefono: { txt: "+39 333 1234567", obbligatorio: true },
          email: { txt: "mario.rossi@test.it", obbligatorio: true }
        },
        file: {
          documentoIdentita: { url: "https://storage.googleapis.com/mock-id.pdf", obbligatorio: true }
        }
      }
    };

    // SCENARIO 1: Token Scaduto ma Cantiere Attivo -> Deve essere storicizzato ed eliminato
    const refScaduto = doc(db, 'aree_riservate_clienti', 'token_scaduto_test');
    batch.set(refScaduto, {
      token: 'token_scaduto_test',
      idCliente: 200, //[cite: 1, 2]
      idLavoro: 1370, //[cite: 1, 2]
      statoLavoro: 'attivo',
      dataScadenza: Timestamp.fromDate(dataPassata),
      questionari: questionarioMock
    });

    // SCENARIO 2: Token Non Scaduto ma Lavoro Disattivato -> Deve essere storicizzato ed eliminato
    const refDisattivato = doc(db, 'aree_riservate_clienti', 'token_disattivato_test');
    batch.set(refDisattivato, {
      token: 'token_disattivato_test',
      idCliente: 200, //[cite: 1, 2]
      idLavoro: 1370, //[cite: 1, 2]
      statoLavoro: 'disattivato',
      dataScadenza: Timestamp.fromDate(dataFutura),
      questionari: questionarioMock
    });

    // SCENARIO 3: Token Attivo e Non Scaduto -> Deve rimanere intatto in questa collezione
    const refValido = doc(db, 'aree_riservate_clienti', 'token_attivo_valido_test');
    batch.set(refValido, {
      token: 'token_attivo_valido_test',
      idCliente: 200, //[cite: 1, 2]
      idLavoro: 1370, //[cite: 1, 2]
      statoLavoro: 'attivo',
      dataScadenza: Timestamp.fromDate(dataFutura),
      questionari: questionarioMock
    });

    try {
      await batch.commit(); //[cite: 6]
      alert('I 3 Scenari di test (Scaduto, Disattivato, Attivo) sono pronti su Firestore live!');
    } catch (error) {
      console.error('Errore durante l\'esecuzione del batch di test:', error);
      alert('Errore di scrittura regole o di rete durante il caricamento del batch.');
    }
  }

  </script>